export var mergeClassName = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return [...args].filter(s => typeof s === 'string').join(' ').split(/\s+/).join(' ');
};
//# sourceMappingURL=mergeClassName.js.map